<!-- 搜索栏 -->
<template>
    <el-autocomplete
        class="citySearch"
        v-model="searchKey"
        :clearable="true"
        :fetch-suggestions="querySearch"
        :placeholder="placeholder"
        @select="handleSelect"
        @focus="setShowtype"
        @blur="setShowtype">
        <div class="searchIcon" style="pointer-events:none;" :class="{'icon_up_amt':showTypeSelect,'icon_down_amt':!showTypeSelect}" slot="suffix">
            <!-- <i class="iconfont icon-iconfont_selectDown"></i> -->
            <i class="el-icon-caret-bottom"></i>
        </div>
        <template slot-scope="{ item }">
            <div class="name">{{ item.CName }}</div>
        </template>
    </el-autocomplete>
</template>

<script>
import ajaxService from '@/server/api.js'
export default {
    data() {
        return {
            cityList:[],
            showTypeSelect:false,
            searchKey:'',//搜索关键字
            focus:false,
        }
    },
    props:{
        placeholder:{
            type:String,
            default(){
                return '不限';
            }
        },
        city:{
            type:String,
            default(){
                return '';
            }
        },
    },
    watch:{
        searchKey(){
            // this.$emit('chooseCity',this.searchKey);
            if(this.searchKey==''){
                this.$emit('chooseCity',this.searchKey)
            }
        }
    },
    created() {
        this.getCityList()
        this.initCity()
    },
    methods: {
        initCity(){
            this.searchKey=this.city
        },
        // 获取城市列表
        getCityList(){
            ajaxService.getCity().then(res=>{
                // console.log('城市列表',res)
                if(!res.ErrorCode){
                    this.cityList=res.Data
                }
            })
        },
        //搜索
        querySearch(queryString, cb) {
            const list = this.cityList;
            var results = queryString ? list.filter(this.createFilter(queryString)) : list;
            // 调用 callback 返回建议列表的数据
            cb(results);
        },
        // 搜索匹配规则
        createFilter(queryString) {
            return (developer) => {
                return (developer.CName.indexOf(queryString) != -1);
            };
        },
        // 选择搜索选项
        handleSelect(item){
            // console.log(item)
            this.searchKey=item.CName
            this.$emit('chooseCity',this.searchKey);
        },
        clearSelect(){
            //html @clear="clearSelect"
            this.$emit('chooseCity',this.searchKey);
        },
        setShowtype(){
            this.showTypeSelect=!this.showTypeSelect;
        },
    }
}
</script>

<style lang="scss" scoped>
</style>
